module.exports = __webpack_public_path__ + "img/nuxt.fd74ab14.png";